import React, { Fragment, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ViedocSidepanelMenuItemElement } from "../../../secure/elements/ViedocReactElements";
import _ from "underscore";
import { t } from "i18next";
import * as zoneActions from "../../../store/actions/zoneActions";
import * as templateActions from "../../../store/actions/templateActions";
import APP_CONST from "../../shared/constants";
import { StorageHelper } from "../../../../utils/storageHelper";
import useResizer from "../../../../hooks/useResizer";

const SidePanel = ({ showSidebar, setShowSidebar, sidePanelRef }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { windowDimensions } = useResizer();

  const {
    metricsData,
    listAudit,
    isManageDropZoneAvailable,
    isRoleListLoaded,
    apiInitConfigObj,
  } = useSelector((store) => store.zone);
  const {
    sharedfilecount,
    privatefilecount,
    settings,
    isEtmfLocked,
    lockStatus,
  } = useSelector((store) => store.template);
  const { error } = useSelector((store) => store.loader);
  const { userRoleList } = useSelector((store) => store.auth);
  const listAuditStringArray = listAudit?.map((list) => {
    return list.name;
  });

  const isListAuditLoad = userRoleList?.includes(t("ADMIN.TEXT_ARCHIVE"))
    ? !_.isEmpty(listAudit)
    : _.isEmpty(listAudit);

  const eLearningLinkAdmin = "https://help.viedoc.net/c/d02ec9/";
  const eLearningLinkUser = "https://help.viedoc.net/c/66614b/";
  const eLearningLinkArchive = "https://help.viedoc.net/l/a93a04/en/";
  const dropzoneNotInstantiateStudy =
    lockStatus !== APP_CONST.ADMIN_TEMPLATE_STATUS[1]
      ? isManageDropZoneAvailable
      : true;

  const eLearningVisiblity = (userRole) =>
    !_.isEmpty(userRoleList) ? userRoleList?.includes(userRole) : false;

  const eLearningLinks = [
    {
      id: 1,
      label: `${t("COMMON.LABEL_USER_GUIDE")} ↗`,
      link: eLearningLinkUser,
      isVisible: eLearningVisiblity(t("ADMIN.TEXT_TMF")),
    },
    {
      id: 2,
      label: `${t("COMMON.LABEL_ADMIN_GUIDE")} ↗`,
      link: eLearningLinkAdmin,
      isVisible: eLearningVisiblity(t("ADMIN.TEXT_TMFADMIN")),
    },
    {
      id: 3,
      label: `${t("COMMON.LABEL_ARCHIVE_GUIDE")} ↗`,
      link: eLearningLinkArchive,
      isVisible: eLearningVisiblity(t("ADMIN.TEXT_ARCHIVE")),
    },
  ];

  const { pathname } = window?.location;

  const sidePanelObject = [
    {
      groupName: t("ADMIN.TEXT_TMF"),
      menuList: [
        {
          menuName: t("OVERVIEW.TEXT_OVERVIEW"),
          value: "/",
          selected: true,
        },
        {
          menuName: dropzoneNotInstantiateStudy
            ? settings.isshareddropzoneenabled ||
              settings.isprivatedropzoneenabled
              ? t("TMF.DROPZONELABEL_DROPZONE")
              : sharedfilecount >= 1 || privatefilecount >= 1
              ? t("TMF.DROPZONELABEL_DROPZONE")
              : ""
            : "",
          value: "/drop-zone",
          selected: false,
          suffix_badge:
            (settings.isshareddropzoneenabled || sharedfilecount >= 1
              ? sharedfilecount
              : "") +
            (settings.isprivatedropzoneenabled || privatefilecount >= 1
              ? privatefilecount
              : ""),
        },
        {
          menuName: t("ADMIN.ADMINTAB_STRUCTURE"),
          value: "/zone-section",
          selected: false,
        },
        {
          menuName: t("OVERVIEW.TEXT_RECORDS"),
          value: "/records",
          selected: false,
        },
        {
          menuName: t("TMF.TEXT_FLAGGEDBYQC"),
          value: "/flagged",
          selected: false,
          prefix_icon: "flag",
          suffix_badge:
            metricsData.flaggedbyqc > 0 ? metricsData.flaggedbyqc : null,
          prefix_icon_color: "white",
          prefix_icon_background_color: "#f86800",
        },
        {
          menuName: t("TMF.TEXT_AWAITING"),
          value: "/awaiting",
          selected: false,
          prefix_icon: "load",
          suffix_badge:
            metricsData.awaitingreview > 0 ? metricsData.awaitingreview : null,
          prefix_icon_color: "black",
          prefix_icon_background_color: "#cccccc",
        },
        {
          menuName: t("TMF.TEXT_FINALIZED"),
          value: "/finalized",
          selected: false,
          prefix_icon: "check",
          suffix_badge:
            metricsData.finalized > 0 ? metricsData.finalized : null,
          prefix_icon_color: "white",
          prefix_icon_background_color: "#00ac26",
        },
      ],
    },
    {
      groupName: t("ADMIN.TEXT_TMFADMIN"),
      menuList: [
        {
          menuName: t("ADMIN.ADMINTAB_TMFSTRUCTURE"),
          value: "/tmf-structure",
          selected: true,
        },
        {
          menuName: t("ADMIN.ADMINTAB_TEMPLATES"),
          value: "/templates",
          selected: false,
        },
        {
          menuName: t("ADMIN.ADMINTAB_SETTINGS"),
          value: "/tmf-setting",
          selected: false,
        },
        {
          menuName: t("ADMIN.ADMINTAB_STATUS"),
          value: "/status",
          selected: false,
        },
      ],
    },
    {
      groupName: t("ADMIN.TEXT_ARCHIVE"),
      menuList: [
        {
          menuName: listAuditStringArray?.includes("auditTrailReport")
            ? t("ARCHIVE.TEXT_AUDITTRAILREPORT")
            : "",
          value: "/archive",
          selected: true,
        },
        {
          menuName: listAuditStringArray?.includes("emsRepository")
            ? t("ARCHIVE.TEXT_ETMFEMSRESPOSITORY")
            : "",
          value: "/ems-repo",
          selected: false,
        },
      ],
    },
  ];

  const [sideData, setSideData] = useState([]);
  const appSettings = StorageHelper.getAppSettings();

  useEffect(() => {
    setSideData(sidePanelObject);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    metricsData,
    settings,
    userRoleList,
    sharedfilecount,
    privatefilecount,
    listAudit,
  ]);

  const switchHandler = async () => {
    dispatch(templateActions.etmfSwitchTracking({ etmfsystem: "v1" }));
    const redirectURL = appSettings.TMFlegacyuiURL;
    const currentToken = JSON.parse(sessionStorage.getItem("token_info"));

    document.cookie = "tokenInfo=" + currentToken.tokenInfo + "; domain=" + appSettings.domain + "; path=/";
    document.cookie = "tokenExpiry=" + currentToken.tokenexpirydate + "; domain=" + appSettings.domain + "; path=/";
    
    window.open(redirectURL, "_self");
  };

  const handleSelect = (e) => {
    if (windowDimensions.width < APP_CONST.WINDOW_BREAKPOINT) {
      setShowSidebar(false);
      StorageHelper.setSidepanelToggle(false);
    }

    if (!e.target.value) {
      return;
    }
    let relVer =
      apiInitConfigObj.releaseversion !== undefined
        ? `?i=` + apiInitConfigObj.releaseversion
        : "";
    if (
      ["/flagged", "/awaiting", "/finalized", "/records"].includes(
        e.target.value
      )
    ) {
      dispatch(zoneActions.getRecordState(e.target.value));
      pathname !== "/records" && navigate("/records" + relVer);
      return;
    }
    let lastdocumentupdatedon = sessionStorage.getItem("lastdocumentupdatedon");
    let reqPayload = {
      searchKey: "",
      site: "ALL",
      countryCode: "ALL",
      pageCount: 0,
      pageSize: 20000,
      pageNumber: 1,
      artifactId: "",
      sectionid: "",
      category: "",
      milestoneGroup: "ALL",
      milestoneId: "",
      lastdocumentupdatedon:
        lastdocumentupdatedon !== null ? lastdocumentupdatedon : "",
    };
    sessionStorage.setItem("recent_search_info", JSON.stringify(reqPayload));
    navigate(e.target.value + relVer);
  };

  const isGroupExpanded = (groupItem) => {
    const isGroupExpanded = groupItem.menuList.some(
      (item) => pathname === item.value
    );
    return isGroupExpanded;
  };

  const checkRouteExist = () => {
    let isRouteExists = false;
    const userRolePath = [
      {
        userRole: t("ADMIN.TEXT_TMF"),
        rolePath: ["/", "/drop-zone", "/zone-section", "/records"],
      },
      {
        userRole: t("ADMIN.TEXT_TMFADMIN"),
        rolePath: ["/tmf-structure", "/templates", "/tmf-setting", "/status"],
      },
      {
        userRole: t("ADMIN.TEXT_ARCHIVE"),
        rolePath: ["/archive", "/ems-repo"],
      },
    ];
    const checkRouteExists = (userRole, routePath = []) =>
      userRoleList?.includes(userRole) && routePath?.includes(pathname);
    userRolePath?.forEach((roles) => {
      if (checkRouteExists(roles?.userRole, roles?.rolePath)) {
        isRouteExists = true;
      }
    });
    return pathname === "/token" ? true : isRouteExists;
  };

  return (
    <aside
      ref={sidePanelRef}
      className={
        showSidebar
          ? error.errorTxt || isEtmfLocked
            ? "sidebar-active sidebar-error-resize"
            : "sidebar-active"
          : "sidebar-inactive"
      }
    >
      {!_.isEmpty(userRoleList) &&
      isListAuditLoad &&
      checkRouteExist() &&
      isRoleListLoaded ? (
        <viedoc-sidepanel
          class={
            error.errorTxt || isEtmfLocked
              ? "sidebar-container-style"
              : "sidebar-container"
          }
        >
          {sideData?.map((groupItem, index) => (
            <Fragment key={index}>
              {(_.isEmpty(userRoleList) ||
                userRoleList?.includes(groupItem.groupName)) && (
                <viedoc-sidepanel-group
                  display-mode="accordion"
                  label={groupItem.groupName}
                  {...(isGroupExpanded(groupItem) ? { expanded: true } : {})}
                >
                  {!_.isEmpty(userRoleList) && isListAuditLoad ? (
                    <>
                      {groupItem.menuList.map((menuItem, index) => (
                        <Fragment key={index}>
                          {menuItem.menuName && (
                            <ViedocSidepanelMenuItemElement
                              key={menuItem.menuName}
                              value={
                                !_.isEmpty(userRoleList) ? menuItem.value : ""
                              }
                              onClick={(e) =>
                                !_.isEmpty(userRoleList) && handleSelect(e)
                              }
                              selected={
                                !_.isEmpty(userRoleList) &&
                                menuItem.value === pathname
                              }
                            >
                              {menuItem.prefix_icon && (
                                <viedoc-icon
                                  name={menuItem.prefix_icon}
                                  slot="prefix"
                                  style={{
                                    color: menuItem.prefix_icon_color,
                                    backgroundColor:
                                      menuItem.prefix_icon_background_color,
                                  }}
                                ></viedoc-icon>
                              )}
                              {menuItem.menuName}
                              {menuItem?.suffix_badge > 0 && (
                                <viedoc-badge slot="suffix" variant="neutral">
                                  {menuItem.suffix_badge}
                                </viedoc-badge>
                              )}
                            </ViedocSidepanelMenuItemElement>
                          )}
                        </Fragment>
                      ))}
                    </>
                  ) : (
                    <viedoc-spinner
                      class=""
                      style={{ width: "100%", textAlign: "center" }}
                    ></viedoc-spinner>
                  )}
                </viedoc-sidepanel-group>
              )}
            </Fragment>
          ))}
          <viedoc-wordmark
            application-name="learning"
            class="elearning-wordmark"
          ></viedoc-wordmark>
          {eLearningLinks.map(
            (link) =>
              link?.isVisible && (
                <div className="elearning-link" key={link.id}>
                  <viedoc-link href={link.link} target="_blank">
                    {link.label}
                  </viedoc-link>
                </div>
              )
          )}
          <viedoc-link
            class="switch-previous"
            onClick={switchHandler}
            underlined=""
            target="_blank"
          >
            {t("COMMON.TEXT_SWITCHBACK")}
          </viedoc-link>
        </viedoc-sidepanel>
      ) : (
        <div className="sidepanel-container-style">
          <div className="sidepanel-loader">
            <viedoc-spinner></viedoc-spinner>
          </div>
        </div>
      )}
    </aside>
  );
};

export default SidePanel;
